import ApiHelper from '@/services/ApiHelper';

export const getMenuCategories = async () => {
    try {
        return await ApiHelper.get('/menucategories');
    } catch (error) {
        console.error('Failed to fetch menu categories', error);
        return [];
    }
};
